export default __webpack_public_path__ + "static/media/4th of July Watermelon Fest.504ca326.png";